import React from 'react';
import { KanbanIcon, ListIcon } from 'lucide-react';
export type ViewMode = 'list' | 'kanban';
type ViewToggleProps = {
  value: ViewMode;
  onChange: (value: ViewMode) => void;
};
const options: {
  mode: ViewMode;
  label: string;
  icon: React.ElementType;
}[] = [{
  mode: 'list',
  label: 'List',
  icon: ListIcon
}, {
  mode: 'kanban',
  label: 'Kanban',
  icon: KanbanIcon
}];
export function ViewToggle({
  value,
  onChange
}: ViewToggleProps) {
  return <div className="inline-flex rounded-lg border border-gray-200 bg-white p-0.5" role="group" aria-label="View mode" data-id="element-251" data-mp="1g4ovkpe7xnxr">
      {options.map(option => <button key={option.mode} type="button" aria-pressed={value === option.mode} onClick={() => onChange(option.mode)} className={['inline-flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-[12.5px] font-medium transition-colors', value === option.mode ? 'bg-ink text-white' : 'text-gray-600 hover:text-ink'].join(' ')} data-id="element-252" data-mp="1q09w0j3n2g5e">
          <option.icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-253" data-mp="1ntckpmyov172" />
          {option.label}
        </button>)}
    </div>;
}